// BUNDLED: global-bundle.js
export default function() {
	const RIPPLE_MAX_SCALE = 5;
	document.addEventListener('DOMContentLoaded', () => {
		document.body.addEventListener('click',(ev) => {
			if (ev.target.classList.contains('ripple')) {
				ev.target.style.setProperty('--ripple-animation','');

				let radius = Math.max(ev.target.offsetWidth, ev.target.offsetHeight) / RIPPLE_MAX_SCALE;
				ev.target.style.setProperty('--ripple-width', (radius * 2) + 'px');
				ev.target.style.setProperty('--ripple-height', (radius * 2) + 'px');
				ev.target.style.setProperty('--ripple-top', ev.offsetY - radius + 'px');
				ev.target.style.setProperty('--ripple-left', ev.offsetX - radius + 'px');
				setTimeout(() => {
					ev.target.style.setProperty('--ripple-animation','ripple');
				}, 0); 
			}
		});
	});
}
